import { render, staticRenderFns } from "./NewPreOrderUnitForm.vue?vue&type=template&id=05987df6"
import script from "./NewPreOrderUnitForm.vue?vue&type=script&lang=js"
export * from "./NewPreOrderUnitForm.vue?vue&type=script&lang=js"
import style0 from "./NewPreOrderUnitForm.vue?vue&type=style&index=0&id=05987df6&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports